<template>
    <header>
        <div class="flex flex-row justify-between pt-7 py-4 lg:py-7 px-5 max-w-[100rem] mx-auto">
            <div class="hidden flex-col justify-between lg:w-48 lg:flex">
                <a
                    class="no-underline lg:w-48 flex items-start cursor-pointer mt-4 lg:mb-0"
                    @click="navigateTo(localePath(`/`))"
                >
                    <icon-arrow-left
                        class="h-5 w-auto mr-5"
                        filled
                    />
                    {{ $t("layouts.header.back") }}
                </a>
            </div>
            <div class="flex gap-4 lg:gap-10 grow justify-end items-center">
                <form-button
                    :to="localePath(`/`) + '?utm_source=loyalty&utm_medium=website&utm_campaign=loyalty'"
                    element="link"
                    type="text"
                >
                    {{ $t("loyalty.header.to_loyalty") }}
                </form-button>

                <form-button
                    :to="localePath(`/app`) + '?utm_source=loyalty&utm_medium=website&utm_campaign=app_download'"
                    class="w-auto"
                    element="link"
                    type="primary"
                >
                    {{ $t("loyalty.header.download_app") }}
                </form-button>
            </div>
        </div>

        <div
            :class="{ block: route.meta.layout === 'account', hidden: route.meta.layout !== 'account' }"
            class="lg:hidden"
        >
            <account-sidebar-toggle />
        </div>
    </header>
</template>

<script lang="ts" setup>
import IconArrowLeft from "~/public/icons/arrow_left.svg";

defineProps<{
    whiteLogo?: boolean;
}>();

const localePath = useLocalePath();
const route = useRoute();
</script>
